import React from "react";
import { graphql } from "gatsby";
import Layout from "../../../components/Layout";
import StandardBanner from "../../../components/StandardHero/StandardHero";
import SubBanner from "../../../components/SubBanner/SubBanner";
import CardFilter from "../../../components/CardFilter/CardFilter";

const MeetOurTeam = ({ data: { strapiMeetOurTeam, allStrapiTeamMembers } }) => {
  const hero = {
    image:
      strapiMeetOurTeam.hero.image.localFile.childImageSharp.gatsbyImageData,
    showBreadcrumb: strapiMeetOurTeam.hero.showBreadcrumb,
    title: "",
    breadcrumbs: [{ name: "MEET OUR TEAM" }],
  };

  const subBanner = {
    image: strapiMeetOurTeam.subBanner.image.localFile.publicURL,
    heading: strapiMeetOurTeam.subBanner.heading,
  };

  const members = allStrapiTeamMembers.nodes.map((item) => ({
    photo: item?.photo?.localFile?.childImageSharp?.gatsbyImageData,
    firstname: item.firstName,
    surname: item.surname,
    jobTitle: item.jobTitle,
    category: item.catgeory,
    slug: item.slug.toLowerCase(),
  }));

  return (
    <Layout
      seo={{
        title: strapiMeetOurTeam.metaData?.pageTitle,
        description: strapiMeetOurTeam.metaData?.metadescription,
        image: strapiMeetOurTeam.hero.image.localFile.publicURL,
      }}
    >
      <StandardBanner
        image={hero.image}
        title={hero.title}
        showBreadcrumb={hero.showBreadcrumb}
        breadcrumbs={hero.breadcrumbs}
      />
      <SubBanner image={subBanner.image} heading={subBanner.heading} />

      <CardFilter members={members} />
    </Layout>
  );
};

export const query = graphql`
  {
    strapiMeetOurTeam {
      hero {
        showBreadcrumb
        image {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
            publicURL
          }
        }
      }
      subBanner {
        heading
        image {
          localFile {
            publicURL
          }
        }
      }
      metaData {
        pageTitle
        metadescription
      }
    }

    allStrapiTeamMembers {
      nodes {
        photo {
          localFile {
            childImageSharp {
              gatsbyImageData(
                aspectRatio: 1.5
                transformOptions: { cropFocus: NORTH }
              )
              resize(fit: COVER) {
                src
                tracedSVG
                width
                height
                aspectRatio
                originalName
              }
            }
          }
          alternativeText
        }
        firstName
        surname
        jobTitle
        description
        catgeory
        slug
      }
    }
  }
`;

export default MeetOurTeam;
